import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'sb-dropdown-text',
  templateUrl: './sb-dropdown-text.component.html',
  styleUrls: ['./sb-dropdown-text.component.scss'],
  standalone: false,
})
export class SbDropdownTextComponent implements OnInit {
  @Input()
  option: string;

  @Input()
  options: string[];

  @Output()
  onOptionSelected: EventEmitter<string> = new EventEmitter();

  @ViewChild('thedropdown')
  dropdownchild?: any;

  visible: boolean = false;

  blur: boolean = true;

  constructor() {}

  ngOnInit() {
    if (!this.options) {
      this.options = [];
    }
  }

  onClick(option: string) {
    if (option) {
      this.onOptionSelected.emit(option);
    }

    this.blur = true;

    this.hide();
  }

  show() {
    // this.visible = true;
  }

  hide() {
    if (this.blur) {
      this.visible = false;
    }
  }

  preventBlur() {
    this.blur = false;
  }

  click($event) {
    this.visible = !this.visible;

    if (this.visible) {
      setTimeout(() => {
        this.dropdownchild.nativeElement.focus();
      }, 1);

      this.blur = true;
    }
  }
}
